import { getGeoJson } from 'common/services/maps-api';
import { mapApiKey } from './config';
import { printViewportMap } from 'common/services/print-api';
import domToImage from 'dom-to-image-more';
import { lotStatusFilterInputs } from './filters';
import { getStatusColor } from './polygon';
import { usePrintEventStore } from '../store/useMapsStore';
/// Borrows from mortgagejs.js - mortgageCalcBB function. 
/// Copying and pasting, do not learn from this
export async function GetMonthlyPayment(mortgageCalcModel) {
    if (mortgageCalcModel.ListingPrice <= 0)
        return 0;
    let apiRequest = {
        dpp: parseFloat((mortgageCalcModel.DownPaymentPercentage * 100).toFixed(2)),
        down_payment: parseFloat((mortgageCalcModel.DownPaymentPercentage * mortgageCalcModel.ListingPrice).toFixed(2)),
        list_price: mortgageCalcModel.ListingPrice,
        term: mortgageCalcModel.LoanTerm,
        zipcode: mortgageCalcModel.ZipCode,
        loan_type: mortgageCalcModel.IsFHA ? "FHA" : "conventional"
    };
    if (mortgageCalcModel.IncludeCreditScoreInMortCalc) {
        apiRequest = { ...apiRequest, credit_score: mortgageCalcModel.CreditScore };
    }
    var apiResponse = await window.BB.api.loanCalc(apiRequest);
    if (!apiResponse.errors) {
        apiResponse.hoaDues = mortgageCalcModel.MonthlyHOADues;
    }
    let loanEmiCalc;
    var cards = apiResponse.card_details.cards;
    cards.sort(function (a, b) { return a - b; });
    var payments = [];
    var rates = [];
    function ratesCalc(card) {
        /*var principleAndInterest = card.totalPayment * (card.rate * 0.01) * card.loanTerm;      */
        var monthlyRate = (card.rate / 100) / 12;
        var compValue = card.comp_val / 100;
        var parsedRate = card.rate.toLocaleString("en-US");
        var paymentObject = {
            "monthlyRate": monthlyRate,
            "rate": parsedRate,
            "compValue": compValue
        };
        rates.push(monthlyRate);
        rates.sort(function (a, b) { return b - a; });
    }
    for (var i = 0; i < cards.length; i++) {
        ratesCalc(cards[i]);
    }
    for (var i = 0; i < rates.length; i++) {
        let payment;
        let calcString;
        let rateString = (rates[i] * 100 * 12).toLocaleString("en-US");
        if (mortgageCalcModel.IsFHA) {
            var fundingFee = mortgageCalcModel.ListingPrice + (0.0175 * mortgageCalcModel.ListingPrice);
            var loanBalance = mortgageCalcModel.ListingPrice + fundingFee - ((mortgageCalcModel.ListingPrice + fundingFee * mortgageCalcModel.DownPaymentPercentage));
            var pi = loanBalance * rates[i] / (1 - Math.pow(1 + rates[i], -mortgageCalcModel.LoanTerm));
            payment = (pi + apiResponse.taxes + apiResponse.homeInsurance + mortgageCalcModel.MonthlyHOADues + (apiResponse.mortgageInsurance ? apiResponse.mortgageInsurance : 0));
            calcString = `openCalcFha(${mortgageCalcModel.ListingPrice}, ${mortgageCalcModel.ZipCode}, ${mortgageCalcModel.DownPaymentPercentage}, ${mortgageCalcModel.MonthlyHOADues}, ${rateString})`;
        }
        else {
            var loanBalance = mortgageCalcModel.ListingPrice - ((mortgageCalcModel.ListingPrice * mortgageCalcModel.DownPaymentPercentage));
            var pi = loanBalance * rates[i] / (1 - Math.pow(1 + rates[i], -mortgageCalcModel.LoanTerm));
            payment = (pi + apiResponse.taxes + apiResponse.homeInsurance + mortgageCalcModel.MonthlyHOADues);
            calcString = `openCalc(${mortgageCalcModel.ListingPrice}, ${mortgageCalcModel.ZipCode}, ${mortgageCalcModel.DownPaymentPercentage}, ${mortgageCalcModel.MonthlyHOADues}, ${rateString})`;
        }
        if (Math.round((payment - Math.floor(payment)) * 100) > 90) {
            payment = Math.floor(payment) + 1;
        }
        else {
            payment = Math.floor(payment);
        }
        //var parsedPayment = payment;//.toLocaleString("en-US");
        var paymentObject = {
            "payment": payment,
            "calcString": calcString
        };
        payments.push(paymentObject);
    }
    //console.log("Payments" + payments[0].payment + payments[1].payment)
    let price = payments[0].payment;
    let priceCalcString = payments[0].calcString;
    //let buyDownPriceString = payments[1].payment;
    //let buyDownCalcString = payments[1].calcString;
    if (mortgageCalcModel.IsFHA) {
        loanEmiCalc = (apiResponse.pi + apiResponse.taxes + apiResponse.homeInsurance + mortgageCalcModel.MonthlyHOADues + (apiResponse.mortgageInsurance ? apiResponse.mortgageInsurance : 0));
    }
    else {
        loanEmiCalc = (apiResponse.pi + apiResponse.taxes + apiResponse.homeInsurance + mortgageCalcModel.MonthlyHOADues);
    }
    //on BB popup window it rounds the price this way: e.g. 1663.3->1663, 1663.9->1663, 1663.91->1664, 1663.95->1664
    if (Math.round((loanEmiCalc - Math.floor(loanEmiCalc)) * 100) > 90) {
        loanEmiCalc = Math.floor(loanEmiCalc) + 1;
    }
    else {
        loanEmiCalc = Math.floor(loanEmiCalc);
    }
    return loanEmiCalc;
}
export async function handleGetGeoJson(currentBrand, communityId) {
    try {
        const response = await getGeoJson(mapApiKey, currentBrand, communityId);
        const geoJson = await response.json();
        if (response.ok) {
            return geoJson.Features;
        }
        else {
            console.error('Problem with the Geo JSON request', response);
            return -1;
        }
    }
    catch (err) {
        console.error('Problem with getting the geo JSON by brand: ', err);
        return -1;
    }
}
export async function printMap(mapContainer, community, lots, lotStatusFilters, homeFilters) {
    return new Promise(async (resolve, reject) => {
        var scale = 2;
        const domToImageSettings = {
            width: mapContainer.clientWidth * scale,
            height: mapContainer.clientHeight * scale,
            quality: 0.9,
            style: {
                transform: "scale(" + scale + ")",
                transformOrigin: "top left"
            }
        };
        let mapScreenshotUrl = await domToImage.toJpeg(mapContainer, domToImageSettings);
        // To fix issues with ios being slow to load all the images, retry until the file size is realistic
        // Super hacky but it works
        for (let i = 0; i < 10; i++) {
            // When a blank background appears, the image size will be much smaller. Find a value that can determine whether the generation was successful
            if (mapScreenshotUrl.length / 1024 > 200) {
                break;
            }
            else {
                mapScreenshotUrl = await domToImage.toJpeg(mapContainer, domToImageSettings);
            }
        }
        // set state to remove secondary print map element from DOM
        usePrintEventStore.getState().setIsPrintMapRendering(false);
        const processedLotStatusFilters = lotStatusFilterInputs.map((lotStatusEntry) => {
            lotStatusEntry.checked = lotStatusFilters.includes(lotStatusEntry.value);
            return lotStatusEntry;
        });
        const mapRequest = {
            MapCanvasHtmlString: mapScreenshotUrl,
            Lots: lots,
            Community: community,
            LotStatusFilters: processedLotStatusFilters.map((statusFilter) => {
                statusFilter.checkboxColor = getStatusColor(statusFilter.value);
                return statusFilter;
            }),
            HomeFilters: homeFilters
        };
        try {
            const response = await printViewportMap(mapRequest);
            if (response.ok) {
                const pdfBlob = await response.blob();
                // thanks to https://stackoverflow.com/a/42274086/13931027
                // this will allow a PDF to be downloaded with a custom name
                // by appending a download link to a generic <a> element
                var url = window.URL.createObjectURL(pdfBlob);
                var a = document.createElement('a');
                a.href = url;
                a.download = community.Name ? (community.Name.replaceAll(' ', '_') + '.pdf') : "Century_Community.pdf";
                document.body.appendChild(a);
                a.click();
                a.remove();
                resolve();
            }
            else {
                reject('Failed API request' + response);
            }
        }
        catch (err) {
            reject(err);
        }
    });
}
